import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { PriceDiscountPercentage } from '../../Details/Price/PriceDetails/styled';
import { getMyPriceDiscountPercentage } from '../../utils/getPriceDetails';
import type { BadgeContext } from '../types';

const MyPriceDiscountBadge = ({ dealCard, isOverlay }: BadgeContext) => {
  const { isMobile } = useCommonClient();
  // Same percentage as the TSX card: per person, and only above the MyPrice minimum.
  const discountPercentage = getMyPriceDiscountPercentage(
    dealCard?.product?.rate?.price?.price,
    dealCard?.product?.rate?.price?.strikethrough
  );

  if (!discountPercentage) return null;

  return (
    <PriceDiscountPercentage isOverlay={!!isOverlay} isMobile={isMobile}>
      {discountPercentage}
    </PriceDiscountPercentage>
  );
};

export default MyPriceDiscountBadge;
